import React from 'react';
const reds = ['#F17273', '#ED4345', '#E81416', '#BA1012', '#8B0C0D', '#a82843'];

const goldens = ['#FFC966', '#FFB733', '#FFA500', '#CC8400', '#996300', '#2F1612'];

const yellows = ['#FAEB36', '#C8BC2B', '#968D20'];

const greens = ['#AFDB72', '#94CF43', '#79C314', '#619C10', '#49750C'];

const blues = ['#91B1F1', '#6D97EC', '#487DE7', '#3A64B9', '#2B4B8B'];

const darkblues = ['#9386C4', '#6F5EB1', '#4B369D', '#3C2B7E', '#2D205E'];

const purples = ['#A986C4', '#8D5EB1', '#70369D', '#5A2B7E', '#43205E'];

const blacks = ['#0F0D13', '#1D1B20', '#211F26', '#2B2930', '#36343B'];

const colors = reds.concat(goldens, yellows, greens, blues, darkblues, purples, blacks);

const Swatch = (props) => {
  const { colorSelectedValue, setPrimaryColor, setColorSelectedValue, handleInputChange } = props;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
      {colors.length > 0 &&
        colors.map((colorHex, index) => (
          <div
            onClick={() => {
              setColorSelectedValue(colorHex);
              setPrimaryColor(colorHex);
            }}
            key={index}
            style={{
              cursor: 'pointer',
              backgroundColor: colorHex,
              height: 30,
              width: 30,
              borderRadius: 8,
              outline: colorSelectedValue === colorHex ? '2px solid #000' : 'none',
            }}
          />
        ))}
    </div>
  );
};

export default Swatch;
